import {stringify} from 'qs';
import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

import {SEARCH_CACHE_MAX_AGE} from '../../utils/constants';

const ACTION_TYPES = {
  VENUE_PERFORMERS_LOADED: 'VENUE_PERFORMERS_LOADED',
  VENUE_PERFORMERS_RESET: 'VENUE_PERFORMERS_RESET',
};

const namespace = 'venue.performers';

const venuePerformersSelector = createSelector(
  (localState = {}) => localState.venuePerformers,
  (venuePerformers) => venuePerformers
);

const loadPerformers = (props) => {
  return (dispatch, getState) => {
    const STATE = getState();
    const cache = true;
    const cacheMaxAge = SEARCH_CACHE_MAX_AGE;
    const {entityId} = props;
    const FILTERED_PERFORMERS_COUNT = 20;
    const searchOptions = {
      shstore: STATE.gsConfig.shstoreId,
      groupingType: 'P',
      minAvailableTickets: 1,
      parking: false,
      venueId: entityId,
      sort: 'popularity desc',
      fieldList: 'performer',
      start: 0,
      rows: FILTERED_PERFORMERS_COUNT,
    };

    const {lang} = STATE;

    return get({
      host: process.env.REACT_APP_API_HOST,
      path: `/search/catalog/events/v3/eventGroupings/?${stringify(searchOptions)}`,
      headers: {
        Authorization: process.env.REACT_APP_API_SECRET,
        'Accept-Language': lang,
      },
      json: true,
      cache,
      cacheMaxAge,
    }).then((body) => {
      const {groups: venuePerformers = []} = body;
      dispatch({type: ACTION_TYPES.VENUE_PERFORMERS_LOADED, venuePerformers});

      return null;
    });
  };
};

const resetPerformers = () => {
  return (dispatch) => {
    dispatch({type: ACTION_TYPES.VENUE_PERFORMERS_RESET});
  };
};

const controller = new Controller({
  namespace,
  mapStateToProps(state) {
    const localState = this.getLocalState(state);

    return {
      venuePerformers: venuePerformersSelector(localState),
    };
  },
  actionCreators: {
    resetPerformers,
    loadPerformers,
  },
  reducers: [ACTION_TYPES.VENUE_PERFORMERS_LOADED, ACTION_TYPES.VENUE_PERFORMERS_RESET],
});

controller.addResetReducer([ACTION_TYPES.VENUE_PERFORMERS_RESET]);

export default controller;
